import React from 'react';

import ModalContainer, { ModalContainerProps } from './ModalContainer';

interface Props extends ModalContainerProps {}

/**
 * A container for a Modal component that wraps the modal in a `form` HTML element. This container
 * is well suited if you are using form inputs in your dialog, in which case wrapping them in a form
 * allows users to do things like press enter in certain fields to submit the form automatically (by
 * activating the appropriate button).
 *
 * Note that this component does _not_ wrap your Modal in a Form component (e.g., from
 * `@tanium/react-form`).
 */
export default React.forwardRef<HTMLFormElement, Props>((props, ref) => (
  <form
    ref={ref}
    onSubmit={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    <ModalContainer {...props} />
  </form>
));
